import { isCan } from "@/tools";

const store = {
  namespaced: true,
  getters: {
    // eslint-disable-next-line
    instansi_id(state, getters, rootState, rootGetters) {
      const i = rootGetters["instansi/instansi_aktif"];
      return i ? i.id : null;
    },
    // eslint-disable-next-line
    menus(state, getters, rootState, rootGetters) {
      const d = rootGetters["diklat/diklat"].filter(diklat => diklat.is_aktif).slice(0, 3);
      const dT = rootGetters["diklat/diklatTerpilih"];
      if (dT) {
        d.push(dT);
      }

      // list menu
      let menu = [
        {
          icon: "mdi-collage",
          title: "Beranda",
          to: {
            name: "beranda"
          },
          hidden: false
        },
        {
          icon: "mdi-book-open",
          title: "Diklat",
          to: {
            name: "diklat"
          },
          hidden: !isCan("diklat")
        },
        {
          icon: "mdi-book",
          title: "Diklatku",
          to: {
            name: "diklatku"
          },
          hidden: false
        },
        {
          subheader: true,
          title: "Kelola Diklat",
          hidden: !isCan("diklat-read")
        },
        {
          moreActive: true,
          title: "Selengkapnya ...",
          hidden: !isCan("diklat-read")
        },
        {
          more: true,
          title: "Diklat Sebelumnya",
          hidden: !isCan("diklat-read")
        }
      ];

      //list diklat
      let diklats =
        !d || d.length === 0
          ? null
          : d.map(dd => ({
              icon: "mdi-book-open",
              title: dd.nama,
              nama: dd.nama,
              id: dd.id,
              hidden: !isCan("diklat-read"),
              items: [
                {
                  icon: "mdi-google-classroom",
                  title: dd.jenisdiklat.label_kelas,
                  hidden: !isCan("kelas-read"),
                  to: {
                    name: "kelas",
                    params: {
                      instansi_id: getters["instansi_id"],
                      diklat_id: dd.id
                    }
                  }
                },
                {
                  icon: "mdi-google-classroom",
                  title: "Grup Kelas",
                  hidden: !isCan("kelas-read") || dd.mode == 1,
                  to: {
                    name: "groupKelas",
                    params: {
                      instansi_id: getters["instansi_id"],
                      diklat_id: dd.id
                    }
                  }
                },
                {
                  icon: "mdi-account-group",
                  title: "Pengguna",
                  hidden: !isCan("pengguna-read"),
                  to: {
                    name: "pengguna.diklat",
                    params: {
                      instansi_id: getters["instansi_id"],
                      diklat_id: dd.id
                    }
                  }
                }
              ]
            }));

      const test = [];
      //push diklat ke menu
      if (d.length > 0) {
        diklats.forEach(diklat => {
          test.push(diklat);
        });
      }

      const mergeInPlace = (a, b, i = 0) => a.splice(i, 0, ...b);

      mergeInPlace(menu, test, 4);

      return menu;
    },

    moreMenus(state, getters, rootState, rootGetters) {
      const d = rootGetters["diklat/diklat"].filter(diklat => diklat.is_aktif).slice(0, 3);
      const dT = rootGetters["diklat/diklatTerpilih"];
      const dn = rootGetters["diklat/diklat"].filter(diklat => !diklat.is_aktif);
      if (dT) {
        d.push(dT);
      }

      // list menu
      let menu = [
        {
          icon: "mdi-collage",
          title: "Beranda",
          to: {
            name: "beranda"
          },
          hidden: false
        },
        {
          icon: "mdi-book-open",
          title: "Diklat",
          to: {
            name: "diklat"
          },
          hidden: !isCan("diklat")
        },
        {
          icon: "mdi-book",
          title: "Diklatku",
          to: {
            name: "diklatku"
          },
          hidden: false
        },

        {
          subheader: true,
          title: "Kelola Diklat",
          hidden: !isCan("diklat-read")
        },
        {
          moreActive: true,
          title: "Selengkapnya ...",
          hidden: !isCan("diklat-read")
        },
        {
          more: true,
          title: "Diklat Sebelumnya",
          hidden: !isCan("diklat-read")
        }
      ];

      //list diklat
      let diklats =
        !d || d.length === 0
          ? null
          : d.map(dd => ({
              icon: "mdi-book-open",
              title: dd.nama,
              nama: dd.nama,
              id: dd.id,
              hidden: !isCan("diklat-read"),
              items: [
                {
                  icon: "mdi-google-classroom",
                  title: "Kelas",
                  hidden: !isCan("kelas-read"),
                  to: {
                    name: "kelas",
                    params: {
                      instansi_id: getters["instansi_id"],
                      diklat_id: dd.id
                    }
                  }
                },
                {
                  icon: "mdi-google-classroom",
                  title: "Grup",
                  hidden: !isCan("kelas-read") || dd.mode == 1,
                  to: {
                    name: "groupKelas",
                    params: {
                      instansi_id: getters["instansi_id"],
                      diklat_id: dd.id
                    }
                  }
                },
                {
                  icon: "mdi-account-group",
                  title: "Pengguna",
                  hidden: !isCan("pengguna-read"),
                  to: {
                    name: "pengguna.diklat",
                    params: {
                      instansi_id: getters["instansi_id"],
                      diklat_id: dd.id
                    }
                  }
                }
              ]
            }));

      const test = [];
      //push diklat ke menu
      if (d.length > 0) {
        diklats.forEach(diklat => {
          test.push(diklat);
        });
      }

      const mergeInPlace = (a, b, i = 0) => a.splice(i, 0, ...b);

      mergeInPlace(menu, test, 4);

      let pastDiklats =
        !dn || dn.length === 0
          ? null
          : dn.map(ddn => ({
              icon: "mdi-book-open",
              title: ddn.nama,
              nama: ddn.nama,
              id: ddn.id,
              hidden: !isCan("diklat-read"),
              items: [
                {
                  icon: "mdi-google-classroom",
                  title: "Kelas",
                  hidden: !isCan("kelas-read"),
                  to: {
                    name: "kelas",
                    params: {
                      instansi_id: getters["instansi_id"],
                      diklat_id: ddn.id
                    }
                  }
                },
                {
                  icon: "mdi-google-classroom",
                  title: "Grup",
                  hidden: !isCan("kelas-read") || ddn.mode == 1,
                  to: {
                    name: "groupKelas",
                    params: {
                      instansi_id: getters["instansi_id"],
                      diklat_id: ddn.id
                    }
                  }
                },
                {
                  icon: "mdi-account-group",
                  title: "Pengguna",
                  hidden: !isCan("pengguna-read"),
                  to: {
                    name: "pengguna.diklat",
                    params: {
                      instansi_id: getters["instansi_id"],
                      diklat_id: ddn.id
                    }
                  }
                }
              ]
            }));

      const pastDiklat = [];
      //push diklat ke menu
      if (dn.length > 0) {
        pastDiklats.forEach(diklat => {
          pastDiklat.push(diklat);
        });
      }

      const mergeInPlaceMore = (a, b, i = 0) => a.splice(i, 0, ...b);

      mergeInPlaceMore(menu, pastDiklat, menu.length);

      return menu;
      // const d = rootGetters["diklat/diklat"].filter(diklat => !diklat.is_aktif);
      //
      // //list diklat
      // let diklats =
      //   !d || d.length === 0
      //     ? null
      //     : d.map(dd => ({
      //         icon: "mdi-book-open",
      //         title: dd.nama,
      //         nama: dd.nama,
      //         id: dd.id,
      //         hidden: !isCan("diklat-read"),
      //         items: [
      //           {
      //             icon: "mdi-google-classroom",
      //             title: "Kelas",
      //             hidden: !isCan("kelas-read"),
      //             to: {
      //               name: "kelas",
      //               params: {
      //                 instansi_id: getters["instansi_id"],
      //                 diklat_id: dd.id
      //               }
      //             }
      //           },
      //           {
      //             icon: "mdi-google-classroom",
      //             title: "Grup",
      //             hidden: !isCan("kelas-read") || dd.mode == 1,
      //             to: {
      //               name: "groupKelas",
      //               params: {
      //                 instansi_id: getters["instansi_id"],
      //                 diklat_id: dd.id
      //               }
      //             }
      //           },
      //           {
      //             icon: "mdi-account-group",
      //             title: "Pengguna",
      //             hidden: !isCan("pengguna-read"),
      //             to: {
      //               name: "pengguna.diklat",
      //               params: {
      //                 instansi_id: getters["instansi_id"],
      //                 diklat_id: dd.id
      //               }
      //             }
      //           }
      //         ]
      //       }));
      //
      // const pastDiklat = [];
      // //push diklat ke menu
      // if (d.length > 0) {
      //   diklats.forEach(diklat => {
      //     pastDiklat.push(diklat);
      //   });
      // }
      //
      // return pastDiklat;
    }
  }
};

export default store;
